"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIn = exports.objectValuesSortedByKey = exports.isValidString = exports.isValidObjectButNotArray = exports.isValidObject = exports.getIn = void 0;
var _reportError = _interopRequireDefault(require("./reportError"));
const isValidString = string => typeof string === 'string' && string.trim().length > 0;
exports.isValidString = isValidString;
const isValidObject = object => typeof object === 'object' && object !== null;
exports.isValidObject = isValidObject;
const isValidObjectButNotArray = object => typeof object === 'object' && object !== null && !Array.isArray(object);
exports.isValidObjectButNotArray = isValidObjectButNotArray;
const getIn = (object, keyArray) => {
  if (!keyArray.every(key => typeof key === 'string' || typeof key === 'number' || typeof key === 'boolean')) {
    throw new TypeError('Expected keys to be strings, numbers, or booleans.');
  }
  return keyArray.reduce((anObject, key) => {
    if (!isValidObject(anObject)) {
      return undefined;
    }
    return anObject[key];
  }, object);
};
exports.getIn = getIn;
const setIn = (object, keyArray, value) => {
  const keysExceptLast = keyArray.slice(0, -1);
  const finalObject = keysExceptLast.reduce((anObject, key) => {
    if (anObject[key] === undefined || anObject[key] === null) {
      // eslint-disable-next-line no-param-reassign -- TODO: Replace
      anObject[key] = {};
    } else if (!isValidObject(anObject[key])) {
      var _window, _window2;
      const currentError = 'Unwilling to overwrite value with an empty object.';
      (0, _reportError.default)('invalidObjectError', currentError, ((_window = window) === null || _window === void 0 ? void 0 : _window.UCMPageLocale) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scriptSupplierPageLocale));
      throw new Error(currentError);
    }
    return anObject[key];
  }, object);
  finalObject[keyArray[keyArray.length - 1]] = value;
};
exports.setIn = setIn;
const objectValuesSortedByKey = object => Object.keys(object).sort().map(key => object[key]);
exports.objectValuesSortedByKey = objectValuesSortedByKey;